import React from "react";

export function ElateMark({ className = "h-7 w-7", glow = true }) {
    return (
        <svg
            viewBox="0 0 40 40"
            className={className}
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true"
        >
            <defs>
                <linearGradient id="elate-grad" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
                    <stop offset="0%" stopColor="#0066FF" />
                    <stop offset="100%" stopColor="#FF5500" />
                </linearGradient>
                {glow && (
                    <filter id="elate-glow" x="-30%" y="-30%" width="160%" height="160%">
                        <feGaussianBlur stdDeviation="2.4" />
                    </filter>
                )}
            </defs>
            {glow && (
                <path
                    d="M20 3 L36 12 L36 28 L20 37 L4 28 L4 12 Z"
                    fill="url(#elate-grad)"
                    opacity="0.55"
                    filter="url(#elate-glow)"
                />
            )}
            <path
                d="M20 3 L36 12 L36 28 L20 37 L4 28 L4 12 Z"
                stroke="url(#elate-grad)"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M14 14 H26 M14 20 H22 M14 26 H26"
                stroke="white"
                strokeWidth="1.7"
                strokeLinecap="round"
            />
        </svg>
    );
}

export function ElateWordmark({ className = "" }) {
    return (
        <div className={`flex items-center gap-2 ${className}`}>
            <ElateMark className="h-7 w-7" />
            <span className="font-display text-[17px] font-semibold tracking-tight text-white">
                Elate <span className="text-zinc-400 font-light">OS</span>
            </span>
        </div>
    );
}
